import { render, staticRenderFns } from "./ApproveAlert.vue?vue&type=template&id=09e9c0b9&"
import script from "./ApproveAlert.vue?vue&type=script&lang=js&"
export * from "./ApproveAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports